<template>
  <div>
    <div class="body">
      <div class="image_area">
        <div class="image_upload" @click="handleImageUploadClick" @dragover.prevent @drop="handleImageDrop"
          v-loading="loading">
          <div class="tips"> 拖拽或点击上传图像</div>
          <img v-if="imagePath" :src="imagePath" alt="">
          <div v-if="imagePath" class="delete_image" @click.stop="deleteImage"> 清空图像</div>
          <div class="paste iconfont" @click.stop="warningTips">&#xe612; 粘贴</div>
        </div>
        <div class="gap"></div>
        <div class="parameters">
          <div class="document">
            <div class="top_tips_01 iconfont">&#xe605; 文档输入说明</div>
            <span title="点击观看操作视频" @click="show_video">&nbsp;[点击观看操作视频]</span>
          </div>
          <div class="model">
            <div class="iconfont">&#xe696; Tips:上传图片格式为jpg/png</div>
          </div>
          <div class="model">
            <div> 选择模式</div>
            <select name="model" id="" v-model="selectedModel">
              <option :value="item" v-for="item in parameter" :key="item">{{ item }}</option>
            </select>
          </div>
          <div class="blur">
            <div> 边缘模糊</div>
            <input type="number" v-model="blur" min="0" max="100">
          </div>
          <div class="offset">
            <div> 外扩偏移</div>
            <input type="number" v-model="offset" min="-50" max="50">
          </div>
          <div class="reversal">
            <div> 反转输出</div>
            <select name="model" id="" v-model="value">
              <option :value="true">开启反转</option>
              <option :value="false">关闭反转</option>
            </select>
          </div>
          <div class="start iconfont" @click="start_process">&#xe632; 开始任务</div>
          <div class="disscuss_area">
            <div class="disscuss iconfont" @click="handelDissvisible(1)">&#xe67c; 讨论区</div>
            <div class="disscuss iconfont" @click="handelDissvisible(2)">&#xe66c; 返图区</div>
          </div>
        </div>
        <div class="gap"></div>
        <div class="panel">
          <div class="show iconfont">&#xe76d; 显示面板</div>
          <img v-if="processedImage" :src="processedImage" alt="">
          <div class="copy_path iconfont" title="复制图像地址" @click="copy_path(processedImage)">&#xe660; 复制</div>
          <div v-if="tips" class="tips">任务正在生成,预计等待3-5S.....</div>
          <div v-if="tips" class="mask"></div>
        </div>
      </div>
    </div>
    <ImageModal class="modal" :visible="isModalVisible" :img_url="imageUrl" @update:visible="isModalVisible = $event"
      :img_show="false" :video_show="true" :video_src="video_src">
    </ImageModal>
    <discussion-board class="discussion-board" :boardvisible="boardvisible" :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"></discussion-board>
  </div>
</template>
<script>
import { genOssImage } from '@/utils/ossPath'
import { v4 as uuidv4 } from 'uuid'
import random from 'random'
import { Message } from 'element-ui'
import { genPrompt } from '@/api/prompt'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import { getOssClient } from '@/utils/oss'
import localStorageUtils from '@/utils/setLocalStorage'
import { getTaskEnd, getTaskStart } from '@/api/user'
import { T_BACKGROUND_REMOVE } from '@/enums/common/modules'
import { getImageSizeByLoading } from '@/utils/helper/function'
import theme from '@/utils/theme'
import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
export default {
  name: 'MatTing',
  data() {
    return {
      reversal: [false, true],
      value: false,
      imageSrc: '',
      imagePath: '',
      processedImage: '',
      tips: false,
      current: '',
      processing: false,
      websocket: null,
      ws: null,
      parameter: [
        'BiRefNet-general',
        'BiRefNet_512x512',
        'BiRefNet-HR',
        'BiRefNet-portrait',
        'BiRefNet-matting',
        'BiRefNet-HR-matting'
      ],
      clientId: '',
      selectedModel: 'BiRefNet-general',
      blur: 0,
      offset: 0,
      loading: false,
      day: theme.day,
      night: theme.night,
      theme: true,
      // 防呆设计
      isModalVisible: false,
      imageUrl: '',
      img_show: false,
      video_src: '',
      // 评论区弹窗
      boardvisible: false,
      disscussType: null
    }
  },
  created() {
    this.imagePath = localStorageUtils.getItem('imagePath')
    this.processedImage = localStorageUtils.getItem('showimage')
    // 将ID值赋给讨论区类型
    this.disscussType = T_BACKGROUND_REMOVE
    // 获取主题
    if (localStorageUtils.getItem('theme') !== null) {
      this.theme = localStorageUtils.getItem('theme')
    } else {
      this.theme = true
    }
  },
  mounted() {
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeystart)
    window.addEventListener('keydown', this.handleKeyPaste)
    // 重刷新释放cuda
    window.addEventListener('beforeunload', this.releaseCuda)
    this.$nextTick(() => {
      this.source_html()
    })
  },
  async beforeDestroy() {
    // 移除键盘事件监听器以防止内存泄漏
    window.removeEventListener('keydown', this.handleKeystart)
    window.removeEventListener('keydown', this.handleKeyPaste)
    try {
      // 释放cuda状态
      const index = await cudaIndexNum()
      if (index) {
        await cuda.changeCudaCurrentStatus(index, 'leisure')
        console.log('current cuda is leisure')
      }
    } catch (e) {
      console.log('no cuda is running')
    }
    // 移除cuda释放监听器
    window.removeEventListener('beforeunload', this.releaseCuda)
  },
  methods: {
    // 修改dissboard的状态
    handelDissvisible(x) {
      if (x === 1) {
        this.boardvisible = true
      }
      if (x === 2) {
        Message.warning('😋开发者功能暂未开放,敬请期待~!')
      }
    },
    // 释放cuda
    async releaseCuda() {
      try {
        // 释放cuda状态
        const index = await cudaIndexNum()
        if (index) {
          await cuda.changeCudaCurrentStatus(index, 'leisure')
          console.log('current cuda is leisure')
        }
      } catch (e) {
        console.log('no cuda is running')
      }
    },
    // 防呆设计
    show_video(event) {
      event.preventDefault()
      event.stopPropagation()
      this.isModalVisible = true
      this.video_src = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/wan_move_show_video/%E4%B8%80%E9%94%AE%E6%8A%A0%E5%9B%BE.mp4'
    },
    // 复制图像地址
    async copy_path(path) {
      if (!path) {
        Message.error('图像地址为空,请确认是否生成图像！')
        return
      }
      try {
        // 不兼容已弃用
        // await navigator.clipboard.writeText(path)

        // 兼容性更好
        const textarea = document.createElement('textarea')
        textarea.value = path
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        Message.success('复制内容成功,可进行下一步操作！')
      } catch {
        Message.error('复制内容失败,请稍后再试！')
      }
    },
    // 添加开始快捷键
    handleKeystart(event) {
      // 检查是否按下了 Ctrl + D
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault() // 阻止默认行为（可选）
        this.start_process() // 执行返回主页的操作
      }
    },
    warningTips() {
      Message.warning('由于浏览器安全协议,请使用Ctrl + V 快捷键进行图片粘贴')
    },
    // 添加 Ctrl+V 快捷键处理
    async handleKeyPaste(event) {
      // 检查是否按下了 Ctrl + V
      if (event.ctrlKey && event.key === 'v') {
        // event.preventDefault()
        try {
          const textarea = document.createElement('textarea')
          textarea.style.position = 'fixed'
          textarea.style.opacity = '0'
          document.body.appendChild(textarea)
          textarea.focus()
          // 创建一个Promise来等待粘贴事件完成
          const clipboardData = await new Promise((resolve, reject) => {
            textarea.addEventListener('paste', () => {
              setTimeout(() => {
                resolve(textarea.value)
              }, 10)
            })
            // 设置超时，防止永远等待
            setTimeout(() => {
              reject(new Error('粘贴操作超时'))
            }, 2000)
          })
          document.body.removeChild(textarea)
          // 使用正则表达式判断字符串是否以常见图片格式结尾
          const imageRegex = /\.(png|jpe?g|gif|bmp|webp)$/i
          if (!imageRegex.test(clipboardData)) {
            Message.error('剪切板中的内容不是有效的图片地址（支持的格式：.png, .jpg, .jpeg, .gif, .bmp, .webp)')
          } else {
            // console.log(clipboardData)
            this.imagePath = clipboardData
            localStorageUtils.setItem('imagePath', clipboardData)
            Message.success('已从剪切板粘贴图片地址')
          }
        } catch (err) {
          Message.error('出现系统兼容性错误,请上报错误给开发者!')
        }
      }
    },
    // 上传图片到OSS
    async uploadToOSS(file, ossClient) {
      const tmp = '/input/'
      const fileName = file.name
      console.log('上传到OSS:', tmp + fileName)
      try {
        const result = await ossClient.put(tmp + fileName, file)
        return result.url
      } catch (err) {
        return null
      }
    },
    // 点击上传按钮
    handleImageUploadClick() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = (event) => {
        const file = event.target.files[0]
        if (file) {
          this.processImage(file)
        }
      }
      input.click()
    },
    // 拖拽上传事件
    handleImageDrop(event) {
      event.preventDefault()
      const file = event.dataTransfer.files[0]
      if (file && file.type.startsWith('image/')) {
        this.processImage(file)
      } else {
        Message.error('请上传有效的图片文件')
      }
    },
    //  图片处理函数
    async processImage(file) {
      this.loading = true
      const ossClient = await getOssClient()
      // 上传图片到OSS
      const imageUrl = await this.uploadToOSS(file, ossClient)
      if (imageUrl) {
        this.imagePath = imageUrl // 更新图片路径为OSS的URL
        console.log(imageUrl, typeof imageUrl)
        localStorageUtils.setItem('imagePath', imageUrl)
        Message.success('图片加载成功,可以准备开始任务!')
      } else {
        Message.error('图片上传失败,请检查网络配置!')
      }
      // 同时显示本地预览
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageSrc = e.target.result
      }
      reader.readAsDataURL(file)
      // setItem('imagePath', imageUrl)
      // const res = getItem('imagePath')
      // console.log(res)
      this.loading = false
    },
    deleteImage() {
      this.imagePath = ''
      this.processing = false
      this.tips = false
      localStorage.removeItem('imagePath')
      localStorage.removeItem('showimage')
    },
    // 应用函数
    start_process() {
      console.log('start_process mark')
      this.processedImage = ''
      if (this.imagePath === '' || this.imagePath === null) {
        Message.warning('请先选择图像文件')
        return
      }
      if (this.processing) {
        Message.warning('任务已在进行中，请勿重复提交以免造成错误!')
        return
      }
      const randomint = Math.floor(Math.random() * 1000000) + 1
      const color = `#${randomint.toString(16).padStart(6, '0')}`
      this.processing = true
      this.tips = true
      const invert = this.value
      const imagesrc = this.imagePath
      const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
      const selectmodel = this.selectedModel
      const promptData = {
        10: {
          inputs: {
            url: imagesrc,
            cache: true
          },
          class_type: 'LoadImageByUrl //Browser',
          _meta: {
            title: 'Load Image By URL'
          }
        },
        14: {
          inputs: {
            model: selectmodel,
            mask_blur: this.blur,
            mask_offset: this.offset,
            invert_output: invert,
            refine_foreground: false,
            background: 'Alpha',
            background_color: color,
            image: ['10', 0]
          },
          class_type: 'BiRefNetRMBG',
          _meta: {
            title: 'BiRefNet Remove Background (RMBG)'
          }
        },
        21: {
          inputs: {
            filename: filename,
            access_key_id: OSS_ACCESS_KEY_ID,
            access_key_secret: OSS_ACCESS_KEY_SECRET,
            security_token: '',
            bucket_name: 'mj-comfy-ui',
            endpoint: 'oss-cn-shenzhen.aliyuncs.com',
            image: [
              '14',
              0
            ]
          },
          class_type: 'OSSUploadNode',
          _meta: {
            title: '保存图片到oss'
          }
        },
        22: {
          inputs: {
            filename_prefix: 'ComfyUI',
            images: [
              '14',
              0
            ]
          },
          class_type: 'SaveImage',
          _meta: {
            title: 'Save Image'
          }
        }
      }
      this.clientId = uuidv4()
      const data = {
        prompt: promptData,
        client_id: this.clientId
      }
      // 发送 Prompt 请求
      const sendPromptRequest = async () => {
        try {
          console.log('get prompt response', data)
          return genPrompt(data)
        } catch (error) {
          console.error('发送作图请求失败：', error)
          this.processing = false
          this.tips = false
          return null
        }
      }

      const fetchImageFilename = async (promptId) => {
        try {
          // 直接使用该实例请求历史记录
          const historyRequest = axios.create({
            baseURL: getLastUsedBaseUrl(),
            timeout: 5000,
            headers: {
              'Content-Type': 'application/json'
            }
          })

          const response = await historyRequest.get(`/history/${promptId}`)
          const promptInfo = response.data[promptId]
          const promptIndex = 2 // prompt信息的下标
          const inputIndex = 21 // prompt信息组件名的下标

          console.log(promptInfo)
          if (promptInfo.status.status_str === 'success') {
            const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)

            const imagepath = genOssImage(tmp[0])
            localStorageUtils.setItem('showimage', imagepath)
            const info = {
              details: [{ path: imagepath }]
            }
            getTaskEnd({ result: JSON.stringify(info) }, this.taskLogId)
            this.processedImage = imagepath
            this.processing = false
          } else {
            console.error('获取历史记录失败，状态码：', response.status)
          }
        } catch (error) {
          console.error('获取图像文件名失败：', error)
        }
      }

      const listenToProgress = (promptId) => {
        this.ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${this.clientId}`)
        const wsTimeout = setTimeout(() => {
          Message.warning('网络连接超时,请重新尝试!')
          this.ws.close()
        }, 2000)

        this.ws.onopen = () => {
          console.log('提交服务器开始生成...')
          getTaskStart({
            type: T_BACKGROUND_REMOVE
          }).then(rep => {
            this.taskLogId = rep.data.task.id
          })
          clearTimeout(wsTimeout)
        }
        this.ws.onmessage = async (event) => {
          clearTimeout(wsTimeout)
          const data = event.data
          if (typeof data === 'string') {
            try {
              const msg = JSON.parse(event.data)
              const tmp = JSON.parse(data)
              console.log(`这是返回${msg}`)
              console.log(tmp)

              if (msg.type === 'executing') {
                const data = msg.data
                if (data.node === null && data.prompt_id === promptId) {
                  // console.log('执行完成')
                  this.ws.close()
                  await fetchImageFilename(promptId)
                }
              } else if (msg.type === 'progress') {
                const value = msg.data.value
                const max = msg.data.max
                console.log(`当前进度：${value}/${max}`)
              }
            } catch (error) {
              console.log('获取结果失败，请重试')
            }
          }
        }
        this.ws.onclose = async () => {
          // console.log('与后台链接断开')
          this.processing = false
          this.tips = false
          try {
            // 恢复cuda为空闲状态
            const index = cudaIndexNum()
            // console.log('回复当前cuda状态', index)
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          } catch (error) { console.log(error) }
        }
      }

      (async () => {
        const result = await sendPromptRequest()
        if (result && result.prompt_id) {
          listenToProgress(result.prompt_id)
        }
      })()
    },
    async getTaskEnd(tmp, taskLogId) {
      const imgInfo = await getImageSizeByLoading(tmp)
      const info = {
        details: [{ path: tmp, imgInfo: imgInfo }]
      }
      getTaskEnd({ result: JSON.stringify(info) }, taskLogId)
    },
    // 初始化效果
    source_html() {
      const main = document.querySelector('.image_area')
      main.style.opacity = this.theme === false ? 0.75 : 1
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.active {
  transition: all 0.5s;
  background-color: @basicselect;
  color: @font_black;
}

.el-message--warning {
  background-color: #fff3cd !important;
  color: #856404 !important;
  border: 1px solid #ffeeba !important;
  font-weight: bold;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

.body {
  width: 100vw;
  height: calc(100vh - 185px);
  color: @font_white;

  .title {
    display: flex;
    height: 90px;
    line-height: 80px;
    justify-content: center;
    padding: 0 10px;
    padding-top: 10px;

    div {
      flex: 1;
      font-size: 25px;
      color: @font_black;
      text-align: center;
      cursor: pointer;
      border-radius: 15px;
      border: 2px solid transparent;

      &:hover {
        border: 2px dashed @basicselect;
        transition: all 0.5s;
      }
    }
  }

  .image_area {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    height: calc(100vh - 185px);
    padding: 10px 30px 10px 30px;

    .gap {
      width: 15px;
    }

    .image_upload {
      position: relative;
      flex: 1;
      height: 100%;
      border-radius: 25px;
      background-color: @basicselect;
      cursor: pointer;
      overflow: hidden;
      transition: all 0.5s;

      &:hover {
        transition: all 0.5s;
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
      }

      .tips {
        color: @font_black;
        position: absolute;
        font-size: 25px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%);
        font-family: 'icomoon';
        z-index: 1;
        transition: all 0.5s;

        &:hover {
          font-size: 26px;
          transition: all 0.5s;
        }

        &:active {
          top: 48%;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
        }
      }

      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        outline: none;
        z-index: 2;
      }

      .delete_image {
        position: absolute;
        width: 200px;
        height: 60px;
        font-size: 25px;
        font-family: 'icomoon';
        text-align: center;
        line-height: 60px;
        background-color: @morejoy;
        color: @font_white;
        border-radius: @border_radius;
        top: 15px;
        right: 15px;
        z-index: 3;

        &:active {
          transition: all 0.5s;
          line-height: 50px;
        }
      }

      .paste {
        position: absolute;
        width: 200px;
        height: 60px;
        font-size: 25px;
        font-family: 'icomoon';
        text-align: center;
        line-height: 60px;
        color: @font_gray;
        border-radius: 15px;
        bottom: 15px;
        right: 15px;
        z-index: 5;
        transition: all 0.5s;

        &:active,
        &:hover {
          transition: all 0.5s;
          line-height: 50px;
        }
      }
    }

    .parameters {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
      border-radius: 25px;
      align-items: center;
      height: calc(100vh - 160px);
      font-family: 'icomoon';
      gap: 10px 0;
      justify-content: center;

      .document {
        width: 520px;
        display: flex;
        font-weight: 500;

        .top_tips_01 {
          color: @font_gray;
          font-size: 24px;
          text-indent: 10px;
        }

        span {
          color: @morejoy;
          font-size: 24px;
          cursor: pointer;
        }
      }

      .model {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 500px;
        height: 100px;
        font-size: 25px;
        color: @font_black;
        background-color: @basicselect;
        border-radius: @border_radius;
        gap: 15px;
        transition: all 0.5s;
        cursor: pointer;

        select {
          width: 180px;
          height: 35px;
          font-size: 20px;
          border: 1px solid @basicselect;
          border-radius: 5px;
        }

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }

        &:active {
          line-height: 60px;
          width: 420px;
          height: 110px;
          transition: all 0.5s;
        }
      }

      .blur,
      .offset {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 500px;
        height: 100px;
        font-size: 25px;
        color: @font_black;
        background-color: @basicselect;
        border-radius: @border_radius;
        gap: 15px;
        transition: all 0.5s;
        cursor: pointer;

        input {
          width: 180px;
          height: 35px;
          font-size: 20px;
          border: 1px solid @basicselect;
          border-radius: 5px;
          text-align: center;
        }

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }

        &:active {
          line-height: 60px;
          width: 420px;
          height: 110px;
          transition: all 0.5s;
        }
      }

      .reversal {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 500px;
        height: 100px;
        font-size: 25px;
        color: @font_black;
        background-color: @basicselect;
        border-radius: @border_radius;
        gap: 15px;
        transition: all 0.5s;
        cursor: pointer;

        select {
          width: 180px;
          height: 35px;
          font-size: 20px;
          border: 1px solid @basicselect;
          border-radius: 5px;
          text-align: center;
        }

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }

        &:active {
          line-height: 60px;
          width: 420px;
          height: 110px;
          transition: all 0.5s;
        }
      }

      .start {
        width: 500px;
        height: 100px;
        font-size: 25px;
        text-align: center;
        line-height: 100px;
        font-family: 'icomoon';
        border-radius: @border_radius;
        background-color: @basicselect;
        color: @font_black;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          font-size: 27px;
          transition: all 0.5s;
          box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

        }

        &:active {
          line-height: 60px;
          width: 420px;
          height: 110px;
          transition: all 0.5s;
        }
      }

      .disscuss_area {
        display: flex;
        width: 500px;
        height: 100px;
        gap: 10px;

        .disscuss {
          flex: 1;
          height: 100px;
          font-size: 25px;
          border-radius: @border_radius;
          background-color: @basicselect;
          text-align: center;
          line-height: 100px;
          color: @font_black;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            font-size: 27px;
            transition: all 0.5s;
            box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);

          }
        }
      }
    }

    .panel {
      height: 100%;
      position: relative;
      flex: 1;
      border-radius: 25px;
      background-color: @basicselect;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        transition: all 0.5s;
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
      }

      .show {
        position: absolute;
        border-radius: @border_radius;
        background-color: @morejoy;
        width: 200px;
        height: 60px;
        font-size: 25px;
        text-align: center;
        line-height: 60px;
        top: 25px;
        left: 25px;
        z-index: 5;
      }

      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        outline: none;
        z-index: 2;
      }

      .tips {
        position: absolute;
        width: 100%;
        height: 50px;
        font-size: 25px;
        top: 50%;
        left: 6%;
        text-align: center;
        line-height: 100%;
        transition: all 0.5s;
        color: @font_black;
        font-weight: 500;
        z-index: 4;
      }

      .mask {
        width: 100%;
        height: 100%;
        background-color: @font_gray;
        z-index: 3;
      }

      .copy_path {
        position: absolute;
        text-align: center;
        right: 10px;
        bottom: 10px;
        width: 120px;
        height: 50px;
        font-size: 25px;
        color: @font_gray;
        z-index: 4;
        transition: all 0.5s;

        &:hover {
          font-size: 27px;
        }
      }
    }
  }
}
</style>
